<script lang="ts" setup>
import { useExportCertificateAsString } from "~/modules/certificate/composables/useCertificateExport";
import { useCertificatesACLRoles } from "~/modules/certificate/composables/useCertificates";
import { CACertificateItemType } from "~/modules/certificate/models/CACertificateItemType.enum";
import type { KeystoreCertificate } from "~/modules/certificate/models/KeystoreCertificate.interface";
import ILxcLightDownload from "~icons/lxc-light/download";

const { t } = useI18n();
const { exportCertificateAsString } = useExportCertificateAsString();
const { canViewCertificates } = useCertificatesACLRoles();

const props = defineProps<{
  certificate: KeystoreCertificate;
}>();

const downloadLabel: ComputedRef<string> = computed(() =>
  props.certificate.type === CACertificateItemType.CSR
    ? t("certificates.downloadCSR")
    : t("certificates.download"),
);

const isDownloadDisabled: ComputedRef<boolean> = computed(
  () => !canViewCertificates() || !props.certificate.certificate,
);

const onDownloadCertificateClick = () => {
  if (props.certificate.certificate) {
    exportCertificateAsString(
      props.certificate.certificate,
      props.certificate.alias,
      props.certificate.type,
    );
  }
};
</script>

<template>
  <lxc-button
    html-type="button"
    type="borderless"
    :disabled="isDownloadDisabled"
    :icon="ILxcLightDownload"
    :title="downloadLabel"
    class="invisible"
    @click.stop.prevent="onDownloadCertificateClick"
  />
</template>
<style lang="scss" scoped>
button {
  :deep(svg) {
    height: 20px;
    width: 20px;
  }
}
</style>
